import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useEffect } from "react";
import { Container } from "reactstrap";
import GlobalEarnestDeposit from "./Components/GlobalEarnestDeposit";
import GlobalRentEarnestDeposit from "./Components/GlobalRentEarnestDeposit";

const ConfigPage = () => {
    // Set document title and active menu when component mounts
    useEffect(() => {
        document.title = "Configurations";
        localStorage.setItem('activeMenu', 'configurations');
        
        // Dispatch custom event to notify sidebar
        const event = new CustomEvent('sidebarUpdate');
        window.dispatchEvent(event);
    }, []);

    return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb 
            title="Configurations" 
            pageTitles={[
              { label: "Dashboard", path: "/" },
              { label: "Configurations" }
            ]}
          />
          <GlobalEarnestDeposit />
          <GlobalRentEarnestDeposit />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConfigPage;